import React, { Fragment, useState, useMemo, useEffect } from "react";
import { Lock, Mail, User, Phone, Code, Key } from "react-feather";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Form, FormGroup, Input, InputGroup, Label } from "reactstrap";
import { Btn, H4, H5, H6, LI, P, UL } from "../../../AbstractElements";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import Language from "../../../Layout/Header/Langauge";
import {
  CreateAccount,
  EmailAddress,
  Password,
  PhoneNumber,
  PrivacyPolicy,
  SignIn,
  YourName,
  Continue,
  BackgroundColor,
  OTPTEXT,
} from "../../../Constant";
import {
  FaceBookSVG,
  GoogleSVG,
  InstagramSVG,
  TwitterSVG,
} from "../../../Data/svgIcons";
import imgg from "../../../assets/images/logo/logo.png";

const RegisterFrom = () => {
  const [step, setStep] = useState(1);
  const lang = localStorage?.getItem('i18nextLng');
  const [phoneNumber, setPhoneNumber] = useState();
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [disabled2, setDisabled2] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [otpCode, setOtpCode] = useState();
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [togglePassword2, setTogglePassword2] = useState(false);
  const [togglePassword, setTogglePassword] = useState(false);
  const navigate = useNavigate();

  const handleNext = async (event) => {
    event.preventDefault();
    if (step === 1 && phoneNumber?.trim() !== "" && phoneNumber?.trim()?.length === 10) {
      try {
        const response2 = await axios.post(
          "https://api-portal.nada.org.np/api/users/send-otp",
          {
            phone_number: phoneNumber,
            //password: password,
          }
        );

        if (response2?.data?.success) {
          setDisabled(true);
          setStep(2);
        } else {
          toast.error(response2?.data?.message);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
        if (error.response) {
        } else if (error.request) {
          console.error("Error request:", error.request);
        } else {
          console.error("Error message:", error.message);
        }
      }
    } else {
      toast.error("Please enter valid phone number");
    }
  };

  const validatePassword = (password) => {
    const lengthValid = password.length >= 8;
    const upperCaseValid = /[A-Z]/.test(password);
    const lowerCaseValid = /[a-z]/.test(password);
    const numberValid = /[0-9]/.test(password);
    const specialCharValid = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    return {
        lengthValid,
        upperCaseValid,
        lowerCaseValid,
        numberValid,
        specialCharValid,
    };
  };

  const validation = useMemo(() => validatePassword(password), [password]);

  useEffect(() => {
    if (password !== '') {
            if(validation && validation.lengthValid && validation.upperCaseValid && validation.lowerCaseValid && validation.numberValid && validation.specialCharValid) {
                setIsDisabled(false);
            } else {
                setIsDisabled(true);
            }
    } else {
        setIsDisabled(true);
    }
  },[password, validation]);

  const handleOtp = async (event) => {
    event.preventDefault();
    if (otpCode !== "" && otpCode?.length === 4) {
      try {
        const response2 = await axios.post(
          "https://api-portal.nada.org.np/api/users/verify-otp",
          {
            phone_number: phoneNumber,
            otp_code: otpCode,
          }
        );

        if (response2?.data?.success) {
          setDisabled2(true);
          setStep(3);
        } else {
          toast.error(response2?.data?.message);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
        if (error.response) {
        } else if (error.request) {
          console.error("Error request:", error.request);
        } else {
          console.error("Error message:", error.message);
        }
      }
    } else {
      toast.error("Please enter valid OTP");
    }
  };

  const handleRegister = async (event) => {
    event.preventDefault();
    if (password?.trim() !== "" && !isDisabled) {
      try {
        const response = await axios.post(
          `https://api-portal.nada.org.np/api/users`,
          {
            phone_number: phoneNumber,
            otp_code: otpCode,
            password: password,
          }
        );

        if (response?.data?.success) {
          toast.success("User registered successfully!");
          const name = response?.data?.data?.name ? response?.data?.data?.name : 'null';
        localStorage.setItem("Name", name);
          //const name = response?.data?.data?.name !== null || response?.data?.data?.name !== ''? response?.data?.data?.name : 'null'
          localStorage.setItem("name", 'null');
          localStorage.setItem("token", response?.data?.data?.token);
          localStorage.setItem(
            "currentUser",
            response?.data?.data?.phone_number
          );
          localStorage.setItem("authenticated", "true");
          window.location.href = `${process.env.PUBLIC_URL}/dashboard`;
        } else {

        }
      } catch (error) {
        if (error.response) {
        } else if (error.request) {
          console.error("Error request:", error.request);
        } else {
          console.error("Error message:", error.message);
        }
      }
    } else {
      toast.error("Please enter valid password");
    }
  };

  return (
    <Fragment>
      <Form
      style={{ position: 'relative', height: 700 }}
        className="theme-form login-form"
        onSubmit={
          step === 1 ? handleNext : step === 2 ? handleOtp : handleRegister
        }
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 20,
            paddingBottom: "20px",
          }}
        >
          <img src={imgg} alt="Logo" style={{ width: "100px" }} />
          <div
            className="login-header text-center"
            style={{ paddingTop: "40px", justifySelf: "flex-end" }}
          >
            <H4>{t("Create your account")}</H4>
            <H6>{t("Enter your phone number to start")}</H6>
          </div>
        </div>
        <FormGroup>
          <Label>{t("Phone Number")}</Label>
          <InputGroup>
            <span className="input-group-text">
              <Phone />
            </span>
            <Input
              maxLength={10}
              size={10}
              onChange={(e) => setPhoneNumber(e.target.value)}
              value={phoneNumber}
              disabled={disabled}
              className="form-control"
              type="number"
              required=""
              placeholder="Please Enter Your Phone Number"
            />
          </InputGroup>
        </FormGroup>
        {(step === 2 || step === 3) && (
          <FormGroup>
            <Label>{t("OTP Code")}</Label>
            <InputGroup>
              <span className="input-group-text">
                <Key />
              </span>
              <Input
                className="form-control"
                type={togglePassword ? "text" : "password"}
                //name="login[password]"
                required=""
                disabled={disabled2}
                maxLength={4}
                onChange={(e) => setOtpCode(e.target.value)}
                value={otpCode}
                placeholder={t("Enter 4-digit code")}
              />
              <div
              className="show-hide"
              onClick={() => setTogglePassword(!togglePassword)}
            >
              <span className={togglePassword ? "" : "show"}></span>
            </div>
            </InputGroup>
          </FormGroup>
        )}
        {step === 3 && (
          <FormGroup>
            <Label>{t("Password")}</Label>
            <InputGroup>
              <span className="input-group-text">
                <Lock />
              </span>
              <Input
                className="form-control"
                type={togglePassword2 ? "text" : "password"}
                name="login[password]"
                required=""
                placeholder="*********"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
              />
              <div
              className="show-hide"
              onClick={() => setTogglePassword2(!togglePassword2)}
            >
              <span className={togglePassword2 ? "" : "show"}></span>
            </div>
            </InputGroup>
          </FormGroup>
        )}
        <FormGroup>
          <Btn
            style={{ backgroundColor: "#16323C" }}
            attrBtn={{
              className: "btn-block",
              color: "primary",
              type: "submit",
            }}
          >
            {t("Continue")}
          </Btn>
        </FormGroup>
        <P>
        {t("Already have an account?")}
          <Link to={`${process.env.PUBLIC_URL}/login`} className="ms-2">
          {t("Sign In")}
          </Link>
        </P>
        {step === 3 && (
                  <FormGroup>
                      <Label>Your password must have at least:</Label>
                        <LI>8 to 20 characters</LI>
                     <LI>At least 1 uppercase letter and 1 number</LI>
                       <LI>1 special character (e.g. # ? ! $ &amp; @)</LI>
                    </FormGroup>
       )}
        <div style={{ position: 'absolute', top: 1, right: -60, backgroundColor: '#fff', width: 50, height: 40, alignItems: 'center', display: 'flex', justifyContent:'center', borderRadius: '8px' }}>
        <UL attrUL={{ className: `simple-list flex-row nav-menus` }}>
        <LI attrLI={{ className: 'onhover-dropdown' }}><H6 attrH6={{ className: 'txt-dark mb-0 mt-1' }}>{lang === 'es'? 'NP' : 'EN'}</H6>
            <Language />
          </LI>
          </UL>
        </div>
      </Form>
    </Fragment>
  );
};

export default RegisterFrom;
